// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jfdgdjxvzsmuwofclqyt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpmZGdkanh2enNtdXdvZmNscXl0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwNDAwMDksImV4cCI6MjA1ODYxNjAwOX0.LdmCn6tAQE0J22dspr08r2WEStJphGBE4sZmcx6Fd9A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);